import { useState } from "react";
import { useForm } from "react-hook-form";
import { formatBrDate } from "../../../infra/helpers/date";
import { Botao } from "../../../shared/components/Botao";
import { LoadingPage } from "../../../shared/components/LoadingPage";
import { Sidebar } from "../../../shared/components/MenuSidebar/Sidebar";
import { ConfirmDeleteModal } from "../../../shared/components/Modal/ConfirmDeleteModal";
import { Navbar } from "../../../shared/components/Navbar";
import { PageHeader } from "../../../shared/components/PageHeader/PageHeader";
import { TableInfo } from "../../../shared/components/Table";

import { IconAdicionar } from "../../../shared/Icons/IconAdicionar";
import { IconCSV } from "../../../shared/Icons/IconCSV";
import { IconImport } from "../../../shared/Icons/IconImport";
import { IconMovimentos } from "../../../shared/Icons/IconMovimentos";
import { IconVisibility } from "../../../shared/Icons/IconVisibility";
import { EditContatoModal } from "../../Contatos/components/EditContatoModal";
import useDeleteContato from "../../Contatos/hooks/useDeleteContato";
import { CreateMovimentoModal } from "../components/CreateMovimentoModal";
import { CSVModal } from "../components/CSVDownload/CSVModal";
import { CSVImport } from "../components/CSVImport";
import { EditMovimentoModal } from "../components/EditMovimentoModal";
import { FiltroAvancado } from "../components/FiltroAvancado";
import useMovimentos from "../hooks/useMovimentos";
import deleteMovimento from "../queries/deleteMovimento";
import { columns } from "../util/Colunas";

const pageName = "Movimentos";

const InitialValue = { search: '', numeroNF: '' }

export function MovimentosPage() {
  const [visible, setVisible] = useState<boolean>(false);
  const [visibleContato, setVisibleContato] = useState<boolean>(false);
  const [visibleImport, setVisibleImport] = useState<boolean>(false);
  const [visibleExport, setVisibleExport] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [editId, setEditId] = useState<number>();
  const [deleteId, setDeleteId] = useState<number>();
  const [contatoId, setContatoId] = useState<number>();
  const [dataSearch, setDataSearch] = useState(InitialValue);

  const [visibleEdit, setVisibleEdit] = useState(false);
  const [visibleDelete, setVisibleDelete] = useState(false);

  const [deleteContato, setDeleteContato] = useState(false);
  const { mutate: deletarContato, isLoading: LoadingButton } = useDeleteContato(() => handleCloseLaterDelete());

  const { handleSubmit, control } = useForm();

  const { data } = useMovimentos(dataSearch, page);
  const dataMovimentos = data?.items.map((movimento: any, index: number) => ({
    key: index,
    ContatoNome: movimento.Nome + ' ' + movimento.Sobrenome,
    ...movimento,
  }))

  async function onDelete() {
    const result = await deleteMovimento(deleteId!).then((r) => { return r })
    return result;
  }

  async function onDeleteContato() {
    deletarContato(Number(contatoId));
    setContatoId(undefined);
  }

  function handleCloseLaterDelete() {
    setDeleteContato(!deleteContato);
  }

  function onSubmit(data: any, e: any) {
    e.preventDefault();
    console.log(data);
    setDataSearch(data);
    if (data) {
      setPage(1);
    }
  }

  const colunas = [
    {
      title: "Nota Fiscal",
      dataIndex: "NumeroNotaFiscal",
      key: "NumeroNotaFiscal",
      fixed: "left",
      width: 100,
    },
    {
      title: "Data",
      dataIndex: "DataMovimento",
      key: "DataMovimento",
      render(data: any) {
        return formatBrDate(data);
      },
      width: 120,
    },
    {
      title: "Contato",
      dataIndex: "ContatoNome",
      render: (text: any, record: any, index: any) => {
        return (
          <div className=" flex items-center">
            <button
              className="underline"
              onClick={() => {
                setVisibleContato(!visibleContato);
                setContatoId(record.ContatoId);
              }}

            >
              {text}
            </button>
          </div>
        );
      },
      key: "ContatoNome",
      width: "15rem",
    },
    ...columns,
    {
      title: "Ações",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: 60,
      render: (text: any, record: any, index: any) => {
        return (
          <div className=" flex justify-center items-center">
            <button
              onClick={() => {
                setEditId(record.MovimentoId);
                setVisibleEdit(!visibleEdit);
              }}
              className="bg-gray-400 hover:bg-primary-hover p-1 text-gray-100 rounded-full"
            >
              <IconVisibility width="20" height="20" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="flex flex-row mx-auto">
      <div className="flex flex-row">
        <Sidebar />
        <Navbar content={
          <>
            <i
              className="py-2 px-2 text-primary hover:text-primary-hover cursor-pointer"
              onClick={() => {
                setVisibleExport(true);
              }}
            >
              <IconCSV width="32" height="35" />
            </i>

            <Botao
              texto="Importar CSV"
              icon={<IconImport width="20" height="20" />}
              onClick={() => {
                setVisibleImport(true);
              }}
              className="bg-info hover:bg-info-hover text-white"
            />
          </>
        } />
      </div>
      <div id="tabela-movimento" className="flex flex-col pl-[10rem] w-[85%] mx-auto">
        <PageHeader
          titulo={pageName}
          icon={<IconMovimentos />}
          componente={
            <div id="cabecalho-movimento" className="flex items-center gap-3">

              <FiltroAvancado
                width="w-[15rem]"
                onClick={() => {
                  if (data) {
                    setPage(1);
                  }
                }}
                control={control}
                onSubmit={handleSubmit(onSubmit)}
              />

              <Botao
                id="novo-movimento"
                texto="Novo"
                icon={<IconAdicionar color="#fff" />}
                onClick={() => {
                  setEditId(undefined);
                  setVisible(true);
                }}
                className="bg-primary hover:bg-primary-hover text-white"
              />
            </div>
          }
        />

        {/* Modal de criação e edição de movimento */}
        {editId ?
          <EditMovimentoModal
            visible={visibleEdit}
            MovimentoId={editId}
            onCancel={() => {
              setEditId(undefined);
              setVisibleEdit(!visibleEdit);
            }}
            deleteModal={() => {
              setVisibleDelete(!visibleDelete);
              setVisibleEdit(!visibleEdit);
              setDeleteId(editId);
            }}
          /> :
          <CreateMovimentoModal
            onCancel={() => setVisible(!visible)}
            visible={visible}
          />}

        {/* Tabela da listagem de movimentos  */}
        {!dataMovimentos ?
          <div className="h-[80vh] flex justify-center items-center">
            <LoadingPage />
          </div>
          :
          <TableInfo
            dataSource={dataMovimentos}
            columns={colunas as any}
            scroll={{
              x: window.innerWidth,
            }}
            pagination={{
              current: page,
              pageSize: data?.meta?.itemsPerPage,
              total: data?.meta?.totalItems,
              onChange(p) {
                setPage(p);
              },
            }}
          />
        }

        {/* Modal de deleção de um movimento  */}
        <ConfirmDeleteModal
          isModalOpen={visibleDelete}
          title="Deletar Movimento"
          mensagem="Você tem certeza que desejar excluir este movimento?"
          onDelete={() => {
            onDelete();
            setVisibleDelete(false);
            setEditId(undefined);
          }}
          closeModal={() => {
            setDeleteId(undefined);
            setVisibleDelete(false);
          }}
        />

        {/* Modal de deleção de um contato  */}
        {deleteContato &&
          <ConfirmDeleteModal
            isModalOpen={deleteContato}
            title="Excluir Contato"
            mensagem="Você tem certeza que desejar excluir o contato?"
            onDelete={onDeleteContato}
            isLoading={LoadingButton}
            closeModal={() => setDeleteContato(false)}
          />
        }

        {/* Modal para visualizar um contato na tela de movimentos  */}
        {contatoId && <EditContatoModal
          visible={visibleContato}
          onCancel={() => {
            setContatoId(undefined);
            setVisibleContato(false);
          }}
          deleteModal={() => {
            setDeleteContato(!deleteContato);
            setVisibleContato(false);
          }}
          contatoId={contatoId!}
        />}

        {/* Modal de importação CSV */}
        <CSVImport visible={visibleImport} onCancel={() => setVisibleImport(false)} />

        {/* Modal de exportação CSV */}
        {visibleExport && <CSVModal visible={visibleExport} onCancel={() => setVisibleExport(false)} />}
      </div>
    </div>
  );
}
